<template>
  <div class="py-6">
    <div class="flex justify-between items-center space-x-8 mb-8 border-b pb-4">
      <div>
        <h4 class="text-lg mr-4 font-semibold">
          {{ $t('components.customer.profile.uploads.title') }}
        </h4>
        <p class="text-sm mr-4 opacity-60">
          {{ $t('components.customer.profile.uploads.info') }}
        </p>
      </div>
    </div>

    <upload
      :params="{
        idCustomer: customer.idCustomer
      }"
      icon
      class="mb-12"
      @update="handleUpdate"
    />

    <div v-if="pager.items && pager.items.length" class="flex justify-between items-center space-x-8 mb-8 border-b pb-4">
      <div>
        <h4 class="text-lg mr-4 font-semibold">
          {{ $t('asset.attachedFiles') }}
        </h4>
        <p class="text-sm mr-4 opacity-60">
          {{ $t('components.customer.profile.uploads.info') }}
        </p>
      </div>
    </div>

    <upload-pager :pager="pager" sort />
  </div>
</template>

<script setup lang="ts">
import Upload from '@/components/upload/elements/Upload.vue'
import UploadPager from '@/components/upload/elements/Pager.vue'

import { EndlessListPager } from '@/_api/lib/pager'

interface Props {
  customer?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  customer: null,
})

const { $api } = useNuxtApp()

const pager = reactive(new EndlessListPager((page: number) => ($api as any).customer.uploads(props.customer!.idCustomer, { page }), 20))

const handleUpdate = () => {
  if (!pager.loading) {
    pager.reload()
  }
}
</script>
